import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function CustomerRecieve() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    
    },
    {
      header: "Reference No",
      accessorKey: "ReferenceNo"
    },
    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "Customer",
      accessorKey: "Customer",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
    },
    {
      header: "Note",
      accessorKey: "Note",
    },
   
    {
      header: "Added By",
      accessorKey: "AddedBy",
    },
    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },

  ]);
  const [data] = useState([

  
  ]);
  const [buttonData] = useState([   
    {
      buttonText: "Add Customer Due Receives",
      path: "addCustomerRecieveForm"
    },
    
  ]);
 
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Customer Due Receives"}
        buttonData={buttonData}
      

      />
    </main>
  );
}

export default CustomerRecieve;
